import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Phone from '@material-ui/icons/Phone';

import CreateCommand from 'components/modals/CreateCommand';
import HostActionButton from './HostActionButton';
import {isComponentEnabledForUser, isComponentVisibleForUser, SIP_STATUS} from 'utils';
import { useTranslation } from 'react-i18next';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Edit from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
    hostManagement: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // backgroundColor: '#f0f0f0ff',
        padding: theme.spacing(2),
        borderRadius: '10px',
        marginLeft: theme.spacing(2), marginBottom: theme.spacing(2)
    },
    hostActions: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
    hostButton: {
        flex: 1,
        minWidth: 'calc(50% - 10px)',
        marginBottom: theme.spacing(1),
        '&:last-child': {
            minWidth: '100%',
        },
            '&:not(:last-child)': {
        marginRight: '5px',
    },
        borderRadius: '10px',
        boxShadow: 'none'
    },
    actionButton: {
        minHeight: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(1),

        '& button': {
            width: '100%',
            minWidth: 'unset',
        },
    },
}));

function HostCommands(props) {
        const classes = useStyles();
        const { t } = useTranslation();

        const [openModal, setOpenModal] = useState(false);
        const [selectedCommand, setSelectedCommand] = useState(null);

        const clickCommandButton = (co) => {
            setSelectedCommand(co);
            setOpenModal(true);
        };

        const handleClose = () => {
            setOpenModal(false);
        };

        const {
            host, createParkingHostCommand, sipCall, userUseCases, sipStatus,
            handleCreateTaskOpen,
            hadleHostFavorite, isHostFavorite
        } = props;

        const getCommand = (commands, action) => {
            let co = commands.filter(item=>item.commandName===action)[0];
            if (!co) return <></>
            return <HostActionButton
                key={`command_${action}`}
                className={classes.hostButton}
                disabled={!isComponentEnabledForUser(`${UC_HOST_COMMAND}${co.commandName}`, userUseCases) || host.status === 'STATUS_RED'}
                action={co.commandName}
                handleClick={(event) => {
                    if (event.screenX && event.screenY && event.screenY !== 0 && event.screenX !== 0) {
                        clickCommandButton(co);
                    }
                }}/>
        }

        return (
            <> { host ? (
            <div className={classes.hostManagement}>
                <div style={{display: 'flex', flexDirection: 'row', marginLeft: '-7px'}}>
                    <div style={{fontSize:14, opacity: 0.6, marginLeft: '20px', marginBottom: '10px'}}>{t('BARIER_CONTROL').toUpperCase()}</div>
                    <div style={{marginLeft:'auto', opacity: 0.5, cursor: 'pointer'}}>
                        { !isHostFavorite(host.parkingHostId, TYPE_FT_COMMAND) && 
                            <FavoriteBorderIcon fontSize='small' onClick={()=>{hadleHostFavorite(host.parkingHostId, !isHostFavorite(host.parkingHostId, TYPE_FT_COMMAND), TYPE_FT_COMMAND)}}/>
                        }
                        { isHostFavorite(host.parkingHostId, TYPE_FT_COMMAND) && 
                            <FavoriteIcon fontSize='small' onClick={()=>{hadleHostFavorite(host.parkingHostId, !isHostFavorite(host.parkingHostId, TYPE_FT_COMMAND), TYPE_FT_COMMAND)}}/>
                        }
                    </div>
                </div>

                <div className={classes.hostActions}>
                    {host && host.commands && <>
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnOpen'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnOpen')}
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnDoorOpen'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnDoorOpen')}
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnEnumeration'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnEnumeration')}
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnClose'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnClose')}
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnOpenPerm'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnOpenPerm')}
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnSetText'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnSetText')}
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnSetFullText'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnSetFullText')}
                    </>}
                </div>

                <div style={{display: 'flex', flexDirection: 'row', marginLeft: '-7px'}}>
                    <div style={{fontSize:14, opacity: 0.6, marginLeft: '20px', marginBottom: '10px', marginTop: '5px'}}>{t('SPECIAL_FUNCTIONS').toUpperCase()}</div>
                </div>

                <div className={classes.hostActions}>
                    {host && host.commands && <>
                        { isComponentVisibleForUser(`${UC_HOST_COMMAND}${'cmd_BtnRestart'}`, userUseCases) && getCommand(host.commands, 'cmd_BtnRestart')}
                    </>}
                    {host && isComponentVisibleForUser(UC_TASK_CREATE, userUseCases) && (
                        <HostActionButton
                            className={classes.hostButton}
                            action="createTask2"
                            disabled={!isComponentEnabledForUser(UC_TASK_CREATE, userUseCases)}
                            icon={[<Edit/>]}
                            handleClick={(event) => {
                                if (event.screenX && event.screenY && event.screenY !== 0 && event.screenX !== 0) {
                                    handleCreateTaskOpen({
                                        parkingId: host.parkingId,
                                        parkingHostId: host.parkingHostId,
                                        parkingHost: host.hostName,
                                    });
                                }
                            }}
                        />)}
                    {host && isComponentVisibleForUser(UC_HOST_CALL, userUseCases) && (
                        <HostActionButton
                            key="command_call"
                            className={classes.hostButton}
                            disabled={!host.sipPhoneNumber || !isComponentEnabledForUser(UC_HOST_CALL, userUseCases) || sipStatus!==SIP_STATUS.CONNECTED}
                            action="callIntercom"
                            icon={[<Phone/>]}
                            handleClick={() => {
                                sipCall('call-audio', host.sipPhoneNumber);
                            }}
                        />
                    )}
                </div>

                {openModal && (
                    <CreateCommand
                        opened={openModal}
                        command={selectedCommand}
                        host={host}
                        createParkingHostCommand={createParkingHostCommand}
                        handleClose={handleClose}
                    />
                )}
            </div> ) : null }
            </>
        );
}

HostCommands.propTypes = {
    host: PropTypes.object,
    createParkingHostCommand: PropTypes.func,
};

HostCommands.defaultProps = {
    host: {commands: []},
    createParkingHostCommand: null,
};

const UC_HOST_CALL = 'UC0010';
const UC_HOST_COMMAND = 'UC0011_';
const UC_TASK_CREATE = 'UC0038';
const TYPE_FT_COMMAND = 'FT_COMMAND';

export default HostCommands;
